import { BrandLogoMark } from "@v1/ui/brand-logo-mark";
import { CircleCheck, LoaderCircle } from "lucide-react";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

import { MIGRATION_STEPS, MIGRATION_TIMELINE, delay, stepStart } from "./migration-data";

/** One week of moving, Monday to Friday: each day spins, then ticks off. No AI on stage. */
export function MigrationPlan(): ReactNode {
  const t = useTranslations("marketing.migrationStage");
  const tDays = useTranslations("marketing.migrationStage.days");
  const tSteps = useTranslations("marketing.migrationStage.steps");
  const total = stepStart(MIGRATION_STEPS.length) - MIGRATION_TIMELINE.stepFrom;
  return (
    <div className="mkmg-chat mkmg-plan">
      <div className="mkmg-plan-head">
        <BrandLogoMark width={22} height={22} variant="dark" />
        <span className="mkmg-plan-title">{t("planTitle")}</span>
        <span className="mkmg-plan-week">{t("planWeek")}</span>
      </div>
      <div className="mkmg-plan-track" aria-hidden>
        <span
          className="mkmg-plan-fill"
          style={{ animationDelay: `${MIGRATION_TIMELINE.stepFrom}ms`, animationDuration: `${total}ms` }}
        />
      </div>
      <div className="mkmg-steps mkmg-plan-days">
        {MIGRATION_STEPS.map((step, index) => (
          <div key={step} className="mkmg-step mkmg-plan-day mkmg-rise" style={delay(stepStart(index) - 300)}>
            <span className="mkmg-plan-weekday">{tDays(step)}</span>
            <span className="mkmg-step-text">{tSteps(step)}</span>
            <span className="mkmg-step-icon" aria-hidden>
              <LoaderCircle
                className="mkmg-spinner"
                strokeWidth={2.2}
                style={{ animationDelay: `0ms, ${stepStart(index)}ms` }}
              />
              <CircleCheck
                className="mkmg-step-check mkmg-fade"
                strokeWidth={2.2}
                style={delay(stepStart(index + 1) - 120)}
              />
            </span>
          </div>
        ))}
      </div>
      <div className="mkmg-plan-done mkmg-rise" style={delay(stepStart(MIGRATION_STEPS.length))}>
        <CircleCheck size={18} strokeWidth={2.2} aria-hidden />
        {t("planDone")}
      </div>
    </div>
  );
}
